const url = {
  remote: "/app/remote",
  remoteLock: "/app/remote/lock/equipment",
  blueRemoteLock: "/app/remote/blue/lock/equipment",
  remoteUnlock: "/app/remote/unlock/equipment",
  onlineStatus: "/app/monitoring/onlineStatus",
  homeDocument: "/app/home/document/show/v2.6.6",
  sealDetails: "/app/home/seal/details/{0}",
  sealCheck: "/app/home/seal/check/{0}/{1}",
  monitoringEquipment: "/app/monitoring/equipment/show",
  firmwareUpgrade: "firmware/upgrade",
  firmwareUpgradeSync: "firmware/blue/ota",
  fileUpload: "file/upload/one",

  //v2版本接口
  getSign: "/app/handshake/getSign",
  getBusinessKey: "/app/seal/getBusinessKey",
  equipmentMove: "/app/remote/equipment/move",
  remoteResult: "/app/remote/inquire/type/{0}",
  fingerprintOperateState: "/app/fingerprint/operate/state",
  fingerprintImport: "/app/fingerprint/simple/import",
  documentPrivilegeUpload: "/app/equipment/document/privilege/upload",


  userLogin: "/app/equipment/userLogin",
  userLogout: "/app/equipment/userLogout",
  changeSealEnd: "/app/equipment/changeSeal", // 印章装卸完成后信息同步
  firmwareUpdate: '/app/equipment/firmwareUpdate', // 固件升级信息同步
  stmpDataUpload: "/app/stampdata/uploading",
  simpleUpload: "/app/equipment/document/common/upload",
  simpleTimeoutWarn: "/app/monitoring/timeout/control",
  propertySync: '/app/equipment/property/sync',
  privilegeUpload: '/app/equipment/document/privilege/upload',
  //qrcode
  qrcodeDiff: "/app/qrCode/diff",
  videoCut: "/videoCut",
  monitoringConnect: "/app/monitoring/connect/{0}",

  //ocr
  ocrFile: "/app/ocr/file",
  ocr: "/wechat/manage/ocr/v3.7.1",
  ocrApproval: '/app/ocr/approval', // 人工审批
  ocrReduce: "/app/ocr/chance/reduce",
  ocrAll: "/wechat/manage/ocr/all", // 整份比对接口（仅限有这个接口的服务）

  //操作日志
  operationLog: '/equipment/log/point',

  //指纹
  fingerprint: "/app/fingerprint/blue",
  fingerprintList: "/app/fingerprint/show",
  fingerprintRemoveBle: "/app/fingerprint/simple",
  fingerprintRemove: "/app/fingerprint",
  fingerprintImportState: "/app/fingerprint/simple/import/state",

  stampdataWarning: "/wechat/stampdata/warning"
};

import {  SealUploadManager } from '@hybird/device/utils/uploadManager'
//文件上传管理
export const uploadManager = new SealUploadManager({
  maxRetries: 3,
  maxConcurrent: 2
})

const urlApp = Object.assign({}, url);

const urlWechat = Object.assign({}, url);
replaceUrl(urlWechat, "/wechat");

const urlPhotograph = Object.assign({}, url);
replaceUrl(urlPhotograph, "/photograph");

const urlMini = Object.assign({}, url);
replaceUrl(urlMini, "/mini");

const urlPC = Object.assign({}, url);
replaceUrl(urlMini, "/pc");

function switchApp(type) {
  if (type === 1) {
    Object.assign(url, urlApp);
  } else if (type === 2) {
    Object.assign(url, urlWechat);
  } else if (type === 3) {
    Object.assign(url, urlPhotograph);
  } else if (type === 4) {
    Object.assign(url, urlMini);
  } else if (type === 5) {
    Object.assign(url, urlMini);
  }
}

function replaceUrl(url, replaceUrl) {
  for (const key in url) {
    const u = url[key];
    u.replace("/app", replaceUrl);
  }
}

export default url;
export {switchApp}